module.exports = __webpack_public_path__ + "static/img/banner-zh.0384d2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/banner-zh.png
// module id = U3oE
// module chunks = 0